module.exports = __webpack_public_path__ + "static/media/view-onclick.1857736a.svg";